import React from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PPAOfferPage() {
  return (
    <iframe
      src={`${API}/api/static/ppa-offer-generator`}
      title="PPA Offer Generator"
      style={{ width: "100vw", height: "100vh", border: "none" }}
    />
  );
}
